import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../../pages/Home/Container/home";
import Pricing from "../../pages/Home/components/Pricing";
import Faq from "../../pages/Home/components/faq";
import Profile from "../../pages/Profile/Container/profileCont";
import CreateQr from "../../pages/CreateQr/Container/CreateQrCon";
// import UpdateQr from "../../pages/CreateQr/Container/updateqrCon";
import QrCode from "../../pages/container/qrCon";
import Navbar from "../../pages/Home/Container/navCon";
import Controller from "../../router/containers/controller_cont";
import Error from "../../404";
import UpdateLink from "../../pages/components/updateLink";
import UpdateQrCode from "../../pages/CreateQr/Container/updateqrCon";
import ViewQrCode from "../../pages/container/viewQrCodeCon";

class Routers extends Component {
  render() {
    const { login, onLogout } = this.props;
    let body;
    console.log(login);
    console.log(login.name);
    console.log(login.token);

    switch (true) {
      case login.isHome:
        body = (
          <div>
            <main>
              <Controller />
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <div>
                      <Navbar />
                      <Home />
                    </div>
                  }
                />
                <Route exact path="/Pricing" element={<Pricing />} />
                {/* <Route exact path="/Profile" element={<Profile />} /> */}
                <Route exact path="/faq" element={<Faq />} />
                <Route path="*" element={<Error />} />
                <Route path="/qr" element={<UpdateLink />} />
                <Route exact path="/updateqr/:qrCodeId" element={<UpdateQrCode />} />
              </Routes>
            </main>
          </div>
        );
        break;

      case login.type === "U":
      case login.type === "A":
        body = (
          <div>
            <main>
              <Controller />
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <div>
                      <Navbar />
                      <Home />
                    </div>
                  }
                />
                <Route exact path="/profile" element={<Profile />} />
                <Route exact path="/createQr" element={<CreateQr />} />
                <Route exact path="/updateqr/:qrCodeId" element={<UpdateQrCode />} />
                <Route exact path="/viewqrcode/:qrCodeId" element={<ViewQrCode />} />
                {/* <Route
                  exact
                  path="/updateqr/:qrCodeId"
                  element={<UpdateQr />}
                /> */}
                <Route
                  exact
                  path="/qrcode"
                  element={
                    <div>
                      <Navbar />
                      <QrCode />
                    </div>
                  }
                />
                <Route exact path="/Pricing" element={<Pricing />} />
                <Route exact path="/faq" element={<Faq />} />
                <Route path="/qr" element={<UpdateLink />} />
                <Route path="*" element={<Error />} />
              </Routes>
            </main>
          </div>
        );
        break;

      default:
        body = (
          <div>
            <main>
              <Routes>
                <Route path="*" element={<Error />} />
                <Route path="/qr" element={<UpdateLink />} />
                <Route exact path="/faq" element={<Faq />} />
                <Route exact path="/Pricing" element={<Pricing />} />
              </Routes>
            </main>
          </div>
        );
        break;
    }

    return <Router>{body}</Router>;
  }
}

export default Routers;
